/* unplugin-vue-components disabled */import script from "./message-abstract-text.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-text.vue?vue&type=script&setup=true&lang=ts"

import "./message-abstract-text.vue?vue&type=style&index=0&id=4403514e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4403514e"]])

export default __exports__